import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_62gk1xeh0e: FaireBrandEntity = {
  token: "b_62gk1xeh0e",
  type: "brand",
  name: "Bronte Moon",
  avatarUrl:
    "https://cdn.faire.com/fastly/c91927b419d2238827806e40eb70586b4da642688edfa95bd51c994b1fea07f7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a5021a2ec4caf19054503575fe1908b320921b76aea2283cdc31bafa582b6ea9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c91927b419d2238827806e40eb70586b4da642688edfa95bd51c994b1fea07f7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a5021a2ec4caf19054503575fe1908b320921b76aea2283cdc31bafa582b6ea9.png",
  location: "North Attleboro, MA, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 109,
  isInsider: true,
  description:
    "Bronte Moon is an importer and distributor of British Wool products manufactured in a 182 year old mill in the Yorkshire Dales in England.\n\nOn a visit to the UK in 2014 we visited a local store and found some beautiful throws that we wanted for our house in America. We decided that we couldn't bring them back in our suitcases as we were already overweight so we phoned the mill and asked where we could buy them in the US. We were told that unfortunately the mill had very few customers in America so we decided that we should import and sell them ourselves.\n\nSince then our business has grown rapidly and we now supply many stores across North America and Canada, our direct on line retail business has grown substantially and continues to grow year on year.\n\nThe quality of the products is second to none and we know from the feedback that we have received that our customers love the Design, Quality and Heritage of the products as much as we do.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:47.310Z",
    importedBy: "entity-db-cli",
  },
};
